import Repository from '@/repositories/repository'

const ClientPortalRepository = {
  async getClientPortalData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('client-portal', 'page', params)
  }
}

export default ClientPortalRepository
